// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jj-0";
export var animationContainer = "_jj-1";
export var itemPrice = "_jj-a";
export var itemizedContent = "_jj-9";
export var itemizedHeader = "_jj-7";
export var itemizedRow = "_jj-8";
export var itemizedSection = "_jj-6";
export var modalContent = "_jj-2";
export var orderName = "_jj-3";
export var refundOption = "_jj-4";
export var refundOptionsContainer = "_jj-5";
export var shippingLabel = "_jj-b";
export var totalRow = "_jj-c";